import { createColumnHelper } from "@tanstack/react-table";

const columnHelper = createColumnHelper();

export const transactionColumns = [
  columnHelper.accessor("timestamp", {
    header: () => "Timestamp",
    cell: (props) => props.getValue() || "-",
  }),
  columnHelper.accessor("availableBalance", {
    header: () => "Available Balance",
    cell: (props) => props.getValue() ?? "-",
  }),
  columnHelper.accessor("action", {
    header: () => "Action",
    cell: (props) => props.getValue() || "-",
  }),
  columnHelper.accessor("comment", {
    header: () => "Comment",
    cell: (props) => props.getValue() || "-",
  }),
  columnHelper.accessor("symbol", {
    header: () => "Symbol",
    cell: (props) => props.getValue() || "-",
  }),
  columnHelper.accessor("amount", {
    header: () => "Amount",
    cell: (props) => props.getValue() ?? "-",
  }),
  columnHelper.accessor("balance", {
    header: () => "Balance",
    cell: (props) => props.getValue() ?? "-",
  }),
];
